import { Space, Spin, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { Address, Navigation } from "../../constants/pricing";
import { AmapNaviationPath } from "../../constants/serve";
import NavRouteViewer from "../common/nav.route.viewer";

type IItem = {
  starting: Address;
  destination: Address;
  navigation: Navigation;
  item: any;
}

const Index: React.FC<{ item: IItem }> = (props) => {
  const { starting, destination, navigation } = props.item;
  const distance = Number(navigation?.distance)
  const [LngLats, setLngLats] = useState<AMap.LngLatLike[][]>([]);

  useEffect(() => {
    getLngLats()
  }, []);

  const getLngLats = React.useCallback(() => {
    if (!navigation) return

    try {
      let selected: AmapNaviationPath = JSON.parse(navigation.routesJsonSelected)!.selected;
      let _laglngs: AMap.LngLatLike[][] = [];

      selected.steps.map(step => {
        let points = step.polyline.split(";");
        let _laglng = points.map(p => {
          let latlngstr = p.split(",")
          let latlng: AMap.LngLatLike = [parseFloat(latlngstr[0]), parseFloat(latlngstr[1])]
          return latlng
        })
        _laglngs = _laglngs.concat(_laglng)
        return _laglng
      })
      setLngLats(_laglngs)

    } catch (error) {
      console.log(error)
    };
  }, [navigation]);

  return (
    <Spin spinning={false}>
      {LngLats.length < 1 && !navigation && <Tag color="orange">该服务没有导航信息</Tag>}
      {distance && <div> <Typography.Text strong>距离：</Typography.Text> {Math.ceil(distance / 1000)}公里</div>}
      <Space size={30} style={{ marginBottom: "8px" }}>
        {starting && <div> <Typography.Text strong>起始地</Typography.Text> {(starting.address + starting.name)}</div>}
        {destination && <div><Typography.Text strong>送达地</Typography.Text> {(destination.address + destination.name)}</div>}
      </Space>
      <NavRouteViewer paths={LngLats}></NavRouteViewer>
    </Spin>
  );
};

export default Index;